export default __webpack_public_path__ + "static/media/audio_39_gato.c5362b38.mp3";